import logo from '../../assets/images/tisoha_logo.png'
import { AppBar, Toolbar, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { NavLink } from 'react-router-dom'
import { Link } from 'react-scroll'

import PrimaryButton from '../buttons/PrimaryButton'
import '../../scss/styles.scss'
import MenuIcon from '@material-ui/icons/Menu'
import IconButton from '@material-ui/core/IconButton'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import { useState } from 'react'

const useStyles = makeStyles(theme => ({
  root: {
    fontFamily: 'Roboto',
    flexGrow: 1
  },
  appbar: {
    background: 'rgba(0, 0, 0, 0.8)',
    padding: theme.spacing(1, 0)
  },
  appbarWrapper: {
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(0, 8)
    },
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(0, 6)
    },
    [theme.breakpoints.up('xs')]: {
      margin: theme.spacing(0, 2)
    }
  },
  title: {
    flexGrow: 1,
    svg: {
      height: '100%',
      width: '40px'
    }
  },
  logo: {
    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(2)
    },
    marginLeft: theme.spacing(0)
  },
  menu: {
    // [theme.breakpoints.up('xs')]: {
    //   display: 'block',
    //   visibility: 'visible'
    // },
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  smallMenu: {
    [theme.breakpoints.up('sm')]: {
      display: 'none'
    },
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      visibility: 'visible'
    }
  },
  link: {
    color: 'white',
    textDecoration: 'none',
    textTransform: 'uppercase',
    fontWeight: '300',
    fontSize: '10px',
    lineHeight: '24px',

    [theme.breakpoints.up('md')]: {
      fontSize: '16px',
      margin: theme.spacing(0, 1)
    },
    [theme.breakpoints.between('sm', 'md')]: {
      fontSize: '12px',
      margin: theme.spacing(0, 1)
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px',
      margin: theme.spacing(0, 0.7)
    },

    ':not(:last-child)': {
      margin: 'none'
    },
    '&:hover': {
      textShadow:
      `0 0 15px #fff,
      0 0 5px rgb(0, 255, 64)
      `
    }
  },
  nameCompany: {
    color: 'white',
    textDecoration: 'none',
    textTransform: 'uppercase',
    fontSize: '10px',
    lineHeight: '24px',
    textShadow:
      `0 0 15px #fff,
      0 0 1px rgb(0, 255, 64)
      `,

    [theme.breakpoints.up('md')]: {
      fontSize: '16px',
      margin: theme.spacing(0, 1)
    },
    [theme.breakpoints.between('sm', 'md')]: {
      fontSize: '16px',
      margin: theme.spacing(0, 1)
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      margin: theme.spacing(0, 1)
      // display: 'none'
    },

    ':not(:last-child)': {
      margin: 'none'
    }
  }
}))

export default function Header() {
  const classes = useStyles()
  const [drawerOpen, setDrawerOpen] = useState(false)

  const scrollToContactForm = () => {
    const element = document.getElementById('contactForm')
    if (element) {
      const yOffset = -100
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({ top: y, behavior: 'smooth' })
    }
    setDrawerOpen(false)
  }

  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={classes.appbar}>
        <Toolbar className={classes.appbarWrapper} variant="dense">
          <Typography className={classes.title}>
            <NavLink className={classes.logo} to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
              <img alt="Tisoha" src={logo} />
              <span className={classes.nameCompany} style={{ paddingLeft: '3px', textWrap: 'nowrap'}}>TISOHA SOFTWARE SOLUTIONS</span>
            </NavLink>
          </Typography>
          <div className={classes.menu}>
            <NavLink className={classes.link} exact to="/">
              HOME
            </NavLink>
            <NavLink className={classes.link} exact to="/services">
              SERVICES
            </NavLink>
            <NavLink className={classes.link} exact to="/portfolio">
              PORTFOLIO
            </NavLink>
            <NavLink className={classes.link} exact to="/industries">
              INDUSTRIES
            </NavLink>
            <NavLink className={classes.link} exact to="/members">
              MEMBERS
            </NavLink>
            <Link
              className={classes.link}
              to="contactForm"
              smooth={true}
              duration={2000}
              offset={-160}
            >
              <PrimaryButton text={'contact us'} isContactButton={true}/>
            </Link>
          </div>
          <div className={classes.smallMenu}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={() => setDrawerOpen(true)}
            >
              <MenuIcon />
            </IconButton>
            <Drawer anchor="left" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
              <List style={{ width: 220 }}>
                <ListItem button component={NavLink} exact to="/" onClick={() => setDrawerOpen(false)}>
                  <ListItemText primary="HOME" />
                </ListItem>
                <ListItem button component={NavLink} exact to="/services" onClick={() => setDrawerOpen(false)}>
                  <ListItemText primary="SERVICES" />
                </ListItem>
                <ListItem button component={NavLink} exact to="/portfolio" onClick={() => setDrawerOpen(false)}>
                  <ListItemText primary="PORTFOLIO" />
                </ListItem>
                <ListItem button component={NavLink} exact to="/industries" onClick={() => setDrawerOpen(false)}>
                  <ListItemText primary="INDUSTRIES" />
                </ListItem>
                <ListItem button component={NavLink} exact to="/members" onClick={() => setDrawerOpen(false)}>
                  <ListItemText primary="MEMBERS" />
                </ListItem>
                <ListItem button onClick={scrollToContactForm}>
                  <ListItemText primary="CONTACT US" />
                </ListItem>
              </List>
            </Drawer>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  )
}
